module.exports = __webpack_public_path__ + "static/img/shouhou.ff22615.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/shouhou.jpg
// module id = o1Zw
// module chunks = 1